import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';

const materialSchema = z.any().optional();
const alterCodeSchema = z.any();
const measurementUnitSchema = z.any().optional();

const materialAlterCodeNestedSchema = z.object({
  id: z.string().optional(),
  material: materialSchema,
  alterCode: alterCodeSchema,
  measurementUnitId: z.string().optional(),
  materialId: z.string().optional(),
  alterCodeId: z.string().optional(),
  measurementUnit: measurementUnitSchema,
});

export const dcMaterialAlterCodeSchema = baseObjectSchema.extend({
  materialAlterCodeId: z.string().optional(),
  representativeId: z.string(),
  isActive: z.boolean().optional(),
  isFromManager: z.boolean().optional(),
  materialAlterCode: materialAlterCodeNestedSchema.optional(),
  materialAlterCodeRemotedCode: z.string(),
  recordMode: z.number().optional(),
});

export const getDCMaterialAlterCodesResponseSchema = z.object({
  data: z.array(dcMaterialAlterCodeSchema),
  count: z.number(),
});

export type GetDCMaterialAlterCodesResponse = z.infer<typeof getDCMaterialAlterCodesResponseSchema>;
